import { jsxs as b, jsx as o } from "react/jsx-runtime";
import { getStylesFromSelectors as T, createPureSelectors as J, createClassNameSelectors as K } from "../../utils/classNameSelectors.js";
import "../../utils/sectionPreview.js";
import { forwardRef as Q } from "react";
import f from "clsx";
import X from "next/link";
import { getButtonIcon as Y } from "./constants.js";
import '../../_assets/Button.gtnpPYFH.css';const Z = "_btn_818rp_44", E = "_disabled_818rp_67", I = "_reverse_818rp_90", M = "_icon_818rp_101", H = "_link_818rp_111", __ = "_linkGray_818rp_111", l_ = "_linkTerminal_818rp_111", i_ = "_noPadding_818rp_114", n_ = "_link_old_818rp_1855", r_ = "_linkGray_old_818rp_1856", e_ = "_linkTerminal_old_818rp_1857", m_ = "_link_new_818rp_1858", o_ = "_linkGray_new_818rp_1859", t_ = "_linkTerminal_new_818rp_1860", a_ = "_primary_old_818rp_2891", s_ = "_primary_new_818rp_2908", c_ = "_primaryV2_old_818rp_2924", p_ = "_primaryV2_new_818rp_2938", w_ = "_secondary_old_818rp_2952", x_ = "_secondary_new_818rp_2969", d_ = "_tertiary_old_818rp_2983", h_ = "_tertiary_new_818rp_3003", u_ = "_goGreen_new_818rp_3023", g_ = "_border_new_818rp_3039", y_ = "_outline_old_818rp_3063", S_ = "_outline_new_818rp_3085", k_ = "_outlineGray_old_818rp_3109", W_ = "_outlineGray_new_818rp_3131", G_ = "_outlineWhite_old_818rp_3155", b_ = "_outlineWhite_new_818rp_3172", T_ = "_linkWhite_new_818rp_3272", f_ = "_white_old_818rp_3282", z_ = "_white_new_818rp_3296", B_ = "_terminal_old_818rp_3310", N_ = "_terminal_new_818rp_3324", V_ = "_outlineTerminal_old_818rp_3338", C_ = "_outlineTerminal_new_818rp_3355", P_ = "_outlineWhiteBorder_old_818rp_3408", v_ = "_outlineWhiteBorder_new_818rp_3415", O_ = "_outlineGrey_old_818rp_3433", $_ = "_outlineGrey_new_818rp_3450", A_ = "_fuchsia_new_818rp_3474", j_ = "_agzPrimary_old_818rp_3489", L_ = "_agzPrimary_new_818rp_3504", R_ = "_agzWhite_old_818rp_3517", F_ = "_agzWhite_new_818rp_3532", U_ = "_fluid_818rp_3569", q_ = "_rounded_818rp_3573", D_ = "_noWrap_818rp_3577", _ = {
  btn: Z,
  disabled: E,
  reverse: I,
  "xxs-large": "_xxs-large_818rp_95",
  icon: M,
  "icon-left": "_icon-left_818rp_105",
  "icon-right": "_icon-right_818rp_108",
  link: H,
  linkGray: __,
  linkTerminal: l_,
  noPadding: i_,
  "with-icon-xxs-large": "_with-icon-xxs-large_818rp_118",
  "xxs-medium": "_xxs-medium_818rp_138",
  "with-icon-xxs-medium": "_with-icon-xxs-medium_818rp_161",
  "xxs-small": "_xxs-small_818rp_181",
  "with-icon-xxs-small": "_with-icon-xxs-small_818rp_204",
  "xxs-xSmall": "_xxs-xSmall_818rp_224",
  "with-icon-xxs-xSmall": "_with-icon-xxs-xSmall_818rp_247",
  "xs-large": "_xs-large_818rp_271",
  "with-icon-xs-large": "_with-icon-xs-large_818rp_294",
  "xs-medium": "_xs-medium_818rp_314",
  "with-icon-xs-medium": "_with-icon-xs-medium_818rp_337",
  "xs-small": "_xs-small_818rp_357",
  "with-icon-xs-small": "_with-icon-xs-small_818rp_380",
  "xs-xSmall": "_xs-xSmall_818rp_400",
  "with-icon-xs-xSmall": "_with-icon-xs-xSmall_818rp_423",
  "s-large": "_s-large_818rp_447",
  "with-icon-s-large": "_with-icon-s-large_818rp_470",
  "s-medium": "_s-medium_818rp_490",
  "with-icon-s-medium": "_with-icon-s-medium_818rp_513",
  "s-small": "_s-small_818rp_533",
  "with-icon-s-small": "_with-icon-s-small_818rp_556",
  "s-xSmall": "_s-xSmall_818rp_576",
  "with-icon-s-xSmall": "_with-icon-s-xSmall_818rp_599",
  "ssm-large": "_ssm-large_818rp_623",
  "with-icon-ssm-large": "_with-icon-ssm-large_818rp_646",
  "ssm-medium": "_ssm-medium_818rp_666",
  "with-icon-ssm-medium": "_with-icon-ssm-medium_818rp_689",
  "ssm-small": "_ssm-small_818rp_709",
  "with-icon-ssm-small": "_with-icon-ssm-small_818rp_732",
  "ssm-xSmall": "_ssm-xSmall_818rp_752",
  "with-icon-ssm-xSmall": "_with-icon-ssm-xSmall_818rp_775",
  "sm-large": "_sm-large_818rp_799",
  "with-icon-sm-large": "_with-icon-sm-large_818rp_822",
  "sm-medium": "_sm-medium_818rp_842",
  "with-icon-sm-medium": "_with-icon-sm-medium_818rp_865",
  "sm-small": "_sm-small_818rp_885",
  "with-icon-sm-small": "_with-icon-sm-small_818rp_908",
  "sm-xSmall": "_sm-xSmall_818rp_928",
  "with-icon-sm-xSmall": "_with-icon-sm-xSmall_818rp_951",
  "m-large": "_m-large_818rp_975",
  "with-icon-m-large": "_with-icon-m-large_818rp_998",
  "m-medium": "_m-medium_818rp_1018",
  "with-icon-m-medium": "_with-icon-m-medium_818rp_1041",
  "m-small": "_m-small_818rp_1061",
  "with-icon-m-small": "_with-icon-m-small_818rp_1084",
  "m-xSmall": "_m-xSmall_818rp_1104",
  "with-icon-m-xSmall": "_with-icon-m-xSmall_818rp_1127",
  "xm-large": "_xm-large_818rp_1151",
  "with-icon-xm-large": "_with-icon-xm-large_818rp_1174",
  "xm-medium": "_xm-medium_818rp_1194",
  "with-icon-xm-medium": "_with-icon-xm-medium_818rp_1217",
  "xm-small": "_xm-small_818rp_1237",
  "with-icon-xm-small": "_with-icon-xm-small_818rp_1260",
  "xm-xSmall": "_xm-xSmall_818rp_1280",
  "with-icon-xm-xSmall": "_with-icon-xm-xSmall_818rp_1303",
  "l-large": "_l-large_818rp_1327",
  "with-icon-l-large": "_with-icon-l-large_818rp_1350",
  "l-medium": "_l-medium_818rp_1370",
  "with-icon-l-medium": "_with-icon-l-medium_818rp_1393",
  "l-small": "_l-small_818rp_1413",
  "with-icon-l-small": "_with-icon-l-small_818rp_1436",
  "l-xSmall": "_l-xSmall_818rp_1456",
  "with-icon-l-xSmall": "_with-icon-l-xSmall_818rp_1479",
  "xl-large": "_xl-large_818rp_1503",
  "with-icon-xl-large": "_with-icon-xl-large_818rp_1526",
  "xl-medium": "_xl-medium_818rp_1546",
  "with-icon-xl-medium": "_with-icon-xl-medium_818rp_1569",
  "xl-small": "_xl-small_818rp_1589",
  "with-icon-xl-small": "_with-icon-xl-small_818rp_1612",
  "xl-xSmall": "_xl-xSmall_818rp_1632",
  "with-icon-xl-xSmall": "_with-icon-xl-xSmall_818rp_1655",
  "xxl-large": "_xxl-large_818rp_1679",
  "with-icon-xxl-large": "_with-icon-xxl-large_818rp_1702",
  "xxl-medium": "_xxl-medium_818rp_1722",
  "with-icon-xxl-medium": "_with-icon-xxl-medium_818rp_1745",
  "xxl-small": "_xxl-small_818rp_1765",
  "with-icon-xxl-small": "_with-icon-xxl-small_818rp_1788",
  "xxl-xSmall": "_xxl-xSmall_818rp_1808",
  "with-icon-xxl-xSmall": "_with-icon-xxl-xSmall_818rp_1831",
  link_old: n_,
  linkGray_old: r_,
  linkTerminal_old: e_,
  link_new: m_,
  linkGray_new: o_,
  linkTerminal_new: t_,
  primary_old: a_,
  primary_new: s_,
  primaryV2_old: c_,
  primaryV2_new: p_,
  secondary_old: w_,
  secondary_new: x_,
  tertiary_old: d_,
  tertiary_new: h_,
  goGreen_new: u_,
  border_new: g_,
  outline_old: y_,
  outline_new: S_,
  outlineGray_old: k_,
  outlineGray_new: W_,
  outlineWhite_old: G_,
  outlineWhite_new: b_,
  linkWhite_new: T_,
  white_old: f_,
  white_new: z_,
  terminal_old: B_,
  terminal_new: N_,
  outlineTerminal_old: V_,
  outlineTerminal_new: C_,
  outlineWhiteBorder_old: P_,
  outlineWhiteBorder_new: v_,
  outlineGrey_old: O_,
  outlineGrey_new: $_,
  fuchsia_new: A_,
  agzPrimary_old: j_,
  agzPrimary_new: L_,
  agzWhite_old: R_,
  agzWhite_new: F_,
  fluid: U_,
  rounded: q_,
  noWrap: D_,
  "slide-in-out": "_slide-in-out_818rp_1",
  "fade-in-out": "_fade-in-out_818rp_1"
}, M_ = [
  "primary",
  "primaryV2",
  "secondary",
  "tertiary",
  "goGreen",
  "outline",
  "border",
  "link",
  "outlineGray",
  "linkGray",
  "linkWhite",
  "white",
  "terminal",
  "outlineTerminal",
  "linkTerminal",
  "outlineWhite",
  "outlineWhiteBorder",
  "outlineGrey",
  "fuchsia",
  "agzPrimary",
  "agzWhite"
], J_ = Q(
  ({
    className: z,
    style: s,
    iconClassName: B,
    component: c = "button",
    type: p = "button",
    variant: N = "primary",
    rounded: V = !1,
    size: w = "large",
    disabled: x,
    fluid: C = !1,
    icon: l,
    iconPosition: d = "left",
    onlyIcon: n = !1,
    onClick: P,
    href: t,
    children: e,
    externalHref: i,
    noWrap: v,
    noPadding: O,
    theme: $ = "new",
    dataTestId: A,
    onTouchStart: j,
    onTouchEnd: L,
    onMouseEnter: h,
    onMouseLeave: u,
    ...r
  }, g) => {
    var W, G;
    const m = (W = t == null ? void 0 : t.toString()) == null ? void 0 : W.trim(), a = !!(m != null && m.length || (G = i == null ? void 0 : i.trim()) != null && G.length), R = a ? X : c, F = T(J(w, "small"), _), U = T(
      K("with-icon", w, "small"),
      _
    ), y = f(
      z,
      _.btn,
      _[`${N}_${$}`],
      !n && F,
      n && U,
      C && _.fluid,
      V && _.rounded,
      x && _.disabled,
      // for Link
      {
        [_.reverse]: d === "right"
      },
      v && _.noWrap,
      O && _.noPadding
    ), S = f(
      _.icon,
      {
        [_[`icon-${d}`]]: l && !n
      },
      B
    ), q = p === "span", k = typeof l == "string" ? Y(l) : l, D = typeof e == "string" ? `${e} (Opens in a new tab)` : "Opens in a new tab";
    return q ? /* @__PURE__ */ b("span", { className: y, style: s, children: [
      l && /* @__PURE__ */ o("span", { ref: g, className: S, ...r, children: k }),
      !n && /* @__PURE__ */ o("span", { children: e })
    ] }) : /* @__PURE__ */ b(
      R,
      {
        ref: g,
        type: !a && c === "button" ? p : null,
        href: m || i,
        className: y,
        disabled: x,
        target: i ? "_blank" : null,
        "aria-label": i || (r == null ? void 0 : r.target) === "_blank" ? D : null,
        onClick: P,
        "data-testid": A,
        ...h && { onMouseEnter: h },
        ...u && { onMouseLeave: u },
        ...!a && { onTouchStart: j, onTouchEnd: L },
        ...r,
        style: s,
        children: [
          l && /* @__PURE__ */ o("span", { className: S, style: { position: "relative" }, children: k }),
          !n && /* @__PURE__ */ o("span", { children: e })
        ]
      }
    );
  }
);
J_.displayName = "Button";
export {
  M_ as BUTTON_VARIANTS,
  J_ as Button
};
